// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"aws":"5f0b544a","lsc":"3fe9dd79","others":"488e8c5a"}[chunkId] + ".chunk.js";
};